const {
  VITE_API_BASE_URL,
  VITE_KNOWLEDGE_API_BASE_URL,
  MODE,
} = import.meta.env;

if (!VITE_API_BASE_URL && MODE === 'production') {
  throw new Error('VITE_API_BASE_URL must be defined in production environment');
}

if (!VITE_KNOWLEDGE_API_BASE_URL && MODE === 'production') {
  throw new Error('VITE_KNOWLEDGE_API_BASE_URL must be defined in production environment');
}

export const API_BASE_URL = VITE_API_BASE_URL ?? 'http://localhost:3001';
export const AI_API_BASE_URL = import.meta.env.VITE_AI_API_BASE_URL ?? API_BASE_URL;
export const KNOWLEDGE_API_BASE_URL =
  VITE_KNOWLEDGE_API_BASE_URL ?? API_BASE_URL;

export const API_PATHS = {
  company: '/company/',
  clients: '/clients/',
  projects: '/projects/',
  projectArchiveSnapshots: '/snapshot/',
  users: '/users/',
  member: '/member/',
  decisionAreas: '/decision-areas/',
  // Phase 3
  conversations: '/conversation/',
  recordings: '/recording/',
  markers: '/markers/',
  registerEntries: '/register-entries',
  // Phase 5 — Artifacts
  artifactDrafts: '/artifacts/drafts',
  artifactWorkspaces: '/artifacts/workspaces/',
  artifactVersions: '/artifacts/versions/',
  // Phase 6 — Governance & Drift
  governanceDashboard: '/governance/dashboard',
  driftTriggers: '/governance/drift-triggers',
  driftTriggerActivate: '/governance/drift-triggers/activate',
  governanceExport: '/governance/export/',
  // Phase 4 — AI
  aiDocuments: '/document/',
  aiDocumentPresign: '/document/upload/initiate',
  aiAnalyzeDocument: '/document/analyze/',
  aiDocumentSummary: '/document/summary',
  aiAnalyzeConversation: '/conversation/analyze',
  aiConversationAnalysisStatus: '/conversation/analysis/',
  aiChatSessions: '/ai/chat-sessions/',
  aiChatSendMessage: '/ai/chat/send',
  aiChatStream: '/ai/chat/stream',
} as const;

export default API_PATHS;
// Note: `API_BASE_URL` and `API_PATHS` are exported for services to consume.
